import HeroContainer from './hero_container';

const Hero = HeroContainer;
export default Hero;
